import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchAttendancesByEmployeeRequest, deleteAttendanceRequest } from "../../../api/attendance";

class AttendanceTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false
  };

  componentDidMount() {
    if (!this.state.data)
      this.fetchAttendanceData(this.props.selectedEmployee, this.props.selectedAttendanceDate)
  }

  UNSAFE_componentWillReceiveProps(nextProps) { 
    this.fetchAttendanceData(nextProps.selectedEmployee, nextProps.selectedAttendanceDate)
  }

  fetchAttendanceData(selectedEmployee, selectedAttendanceDate){
    this.setState({
      loading: true
    });
    
    const startDate = moment(selectedAttendanceDate).startOf('month').format('YYYY-MM-DD');
    const endDate = moment(selectedAttendanceDate).endOf('month').format('YYYY-MM-DD');


    fetchAttendancesByEmployeeRequest({employeeId: selectedEmployee, startDate, endDate},
      result => this.setState({
        data: this.sortAttendancesByDate(result),
        error: null,
        loading: false
      }),
      error => this.setState({error: error.message, loading: false})
    )
  };

  sortAttendancesByDate = (attendances = []) => {
    return [...attendances].sort((a, b) => {
      const firstDate = a.date ? moment.utc(a.date).valueOf() : Infinity;
      const secondDate = b.date ? moment.utc(b.date).valueOf() : Infinity;

      return firstDate - secondDate;
    });
  }

  deleteAttendance = (id) => {
    deleteAttendanceRequest(
      id,
      result => this.fetchAttendanceData(this.props.selectedEmployee, this.props.selectedAttendanceDate),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );

  }

  render() {
    const { data } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Attendance Table"
                category="List of attendance entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm(this.props.selectedEmployee)}>
                      New Entry
                    </CustomButtom>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Time In</th>
                          <th>Break AM Start</th>
                          <th>Break AM End</th>
                          <th>Lunch Start</th>
                          <th>Lunch End</th>
                          <th>Break PM Start</th>
                          <th>Break PM End</th>
                          <th>Time Out</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ?
                          <td colSpan="10" style={{padding: "0"}}>
                            <div className="loader"></div>
                          </td> 
                          :
                          (data && data.length > 0)
                          ? data.map(instance => {
                            return (
                              <tr key={instance._id}>
                                <td>{instance.date ? moment.utc(instance.date).format('MM/DD/YYYY') : 'N/A'}</td>
                                <td>{instance.timeIn || "-"}</td>
                                <td>{instance.breakAmStart || "-"}</td>
                                <td>{instance.breakAmEnd || "-"}</td>
                                <td>{instance.lunchStart || "-"}</td>
                                <td>{instance.lunchEnd || "-"}</td>
                                <td>{instance.breakPmStart || "-"}</td>
                                <td>{instance.breakPmEnd || "-"}</td>
                                <td>{instance.timeOut || "-"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToDetails('attendance', instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToEditForm('attendance', instance._id)}
                                    >
                                      <i className="fa fa-edit" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deleteAttendance(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='10'>This employee has no attedance entries in the database for the month of {moment(this.props.selectedAttendanceDate).format("MMM/YY")}.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default AttendanceTable;
